<template>
  <div class="main-content" ref="mainContent">
    <pulse-loader :loading="loading" :color="loadingColor" class="text-center"/>

    <EmptyModal
      v-if="modalData"
      ref="emptyModal"
      :onModalClose="onModalClose"
      :onModalAccept="() => sendUpdateStatusRequest(true)"
      :modalData="modalData"
    >
      <slot>
        <div class="mb-2">
          <label for="">Сообщение для менеджера</label>
          <textarea v-model="modalData.message" rows="4" class="form-control"/>
        </div>
      </slot>
    </EmptyModal>

    <div v-if="!loading && order" class="card">
      <div class="card-header">
        <h6>Заявка <strong>{{ (order.id + '').substr(-4) }}</strong></h6>
        <!--        <button @click="mixinGoToRouter('TabletMyOrders')" class="btn btn-default">Назад</button>-->
      </div>
      <div class="card-body">
        <p>Клиент: {{ order.client_name || (order.client && order.client.name) }}</p>
        <p>{{ order.address }}</p>
        <p v-if="order.extra_options.address_details"><strong>{{ order.extra_options.address_details }}</strong></p>
        <div v-for="phone in order.phones" class="phone_div">
          <p><a :href="`tel:${phone.full_phone}`">{{ mixinPrintPhone(phone.full_phone) }}</a></p>
          <p v-if="phone.comment">{{ phone.comment }}</p>
        </div>
        <hr>
        <div>
          <table class="table table-sm">
            <thead>
            <tr>
              <th>Препарат</th>
              <th width="50px">Кол.</th>
              <th>Стоимость</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="detail in order.details">
              <td>{{ detail.new_drug.title }}</td>
              <td>{{ detail.qty }}</td>
              <td>{{ detail.price }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-right">
          <p>доставка: <strong>{{ order.delivery_price || 0 }}</strong></p>
          <p>скидка: <strong>{{ order.discount || 0 }}</strong></p>
          <template v-if="+order.pay_method === 3">
            <p>к оплате наличными <strong class="badge badge-info fs-18">{{
                order.price - order.no_cash_price
              }}</strong>
              руб</p>
            <p>(предоплата <strong class="badge badge-info fs-18">{{ order.no_cash_price }}</strong> руб, получена)</p>
          </template>
          <template v-if="+order.pay_method !== 3 && order.credit_card_id">
            <p>к оплате наличными <strong class="badge badge-info fs-18">{{ order.price }}</strong>
              руб</p>
            <div class="alert alert-warning">
              <p>Клиент сообщил о намерении сделать предоплату на карту в размере
                <strong>{{ order.no_cash_price }}</strong> руб, тогда сумма к оплате наличными будет
                <strong>{{ order.price - order.no_cash_price }}</strong> руб.</p>
              <p>Но предоплата ЕЩЕ НЕ получена. Нельзя доставлять эту заявку БЕЗ получения наличных и без подтверждения
                предоплаты на карту</p>
            </div>
          </template>
          <template v-if="+order.pay_method === 1 && !order.credit_card_id">
            <p>итого: <strong class="badge badge-info fs-18">{{ order.price }}</strong></p>
          </template>
        </div>

        <div v-if="false" class="flex justify-content-between mb-2 mt-2">

          <template v-if="+order.pay_method === 1 && !order.credit_card_id">
            <LoadingButton
              title="Реквизиты для оплаты по карте"
              type="button"
              :loading="loadingRequestBtn[order.id]"
              :color="$constants.SUCCESS_COLOR"
              :onClick="() => requestNoCashPayment(order)"
              className="btn btn-outline-success btn-xs"
            />
          </template>

          <div>
            <button @click="() => sendUpdateStatusRequest(false)" v-if="+order.pay_method !== 3 && order.credit_card_id"
                    class="btn btn-outline-success btn-xs">
              Запросить обновление статуса
            </button>
          </div>
          <button type="button" class="btn btn-outline-info btn-xs" @click="getOrder">Обновить статус заявки</button>
        </div>

        <div v-if="readyToSign" class="text_block">
          <hr>
          <div>
            <tabs class="tabs-simple" :options="{ useUrlFragment: false }">
              <tab name="Договор">
                <p>АГЕНТСКИЙ ДОГОВОР от 17.12.2021 г. Москва</p>
                <p>ПРИНЦИПАЛ: Тестовая заявка проверка письма с одной стороны, и АГЕНТ: Компания “Rancor Distribution
                  S.A.” (Republic of Panama, registration number 155591940; юридическое лицо,
                  которое
                  создано
                  в Республике Панама; регистрационный номер 155591940) от имени которой действуют: Вильчинский Виктор
                  на основании учредительных документов и Воронин Павел Евгеньевич на основании
                  доверености
                  от от 01 февраля 2016 года , с другой стороны, вместе именуемые «Стороны», а индивидуально –
                  «Сторона», заключили настоящий агентский договор (далее по тексту – «Договор») о
                  следующем:</p>
                <p>І. Предмет договора</p>
                <p>1.1. Принципал поручает Агенту и обязуется оплатить, а Агент обязуется по заданию Принципала
                  оказывать услуги по доставке, в случае необходимости — хранению, различного рода
                  грузовых
                  отправлений, именуемых в дальнейшем «Товар» на территории Российской Федерации.</p>
                <p>1.2. Стороны по взаимному согласию договорились, что права и обязанности по доставке Товара,
                  совершенным Агентом (или его уполномоченным лицом) в соответствии с настоящим Договором,
                  возникают непосредственно у Принципала, от которого к Агенту поступила оферта на заключение этого
                  Договора.</p>
                <p>1.3. В соответствии с требованиями актов гражданского оборота и условиями этого Договора, Агент не
                  продает Товар Принципалу. Согласно условиям этого Договора, Агент только выполняет
                  поручение Принципала и оказывает услуги по доставке Товара Принципалу.</p>
                <p>1.4. Принципал этим гарантирует, что он является владельцем Товара, и приобрел право собственности на
                  Товар на достаточной правовой основе до момента заключения настоящего Договора,
                  не
                  нарушая при этом нормы действующего законодательства РФ.</p>
                <p>1.5. Принципал также гарантирует, что Товар не является имуществом, которое ограничено в гражданском
                  обороте на территории РФ (в частности, но не исключительно: наркотические
                  средства,
                  химические вещества и т.д.).</p>
                <p>1.6. Наименование, вид, количество, ассортимент и другие особенности Товара, а также место, дата и
                  время доставки Товара Принципалу оговорено сторонами до момента подписания
                  настоящего
                  Договора, что подтверждается, среди прочего, достигнутыми предварительными договоренностями (в том
                  числе, но не исключительно: путем телефонных переговоров; перепиской по электронной
                  почте;
                  факсом или любыми другими действиями (в том числе, совершение Принципалом действий на веб-сайте
                  Агента) и дополнительно указано в Приложении № 1 к настоящему Договору.</p>
                <p>ІІ. Права и обязанности сторон</p>
                <p>2.1. Агент обязуется действовать в интересах Принципала и доставить Товар по указаниям Принципала по
                  которым предварительно достигнуто согласие и которые дополнительно изложены в
                  Приложении
                  № 1 к настоящему Договору.</p>
                <p>2.2. Агент по своему усмотрению без предварительного согласия Принципала вправе привлекать для
                  исполнения поручения Принципала, в разрезе предмета настоящего Договора, третьих
                  лиц.</p>
                <p>2.3. Принципал обязуется при получении Товара передать Агенту (или его уполномоченному лицу) денежные
                  средства за доставку Товара в полном объеме, что соответствует их
                  предварительным
                  договоренностям и отражено в Приложении № 1 к настоящему Договору.</p>
                <p>2.4. Принципал не вправе требовать любые документы, подтверждающие его оплату по настоящему Договору.
                  Стороны договорились, что по условиям настоящего Договора, Стороны не будут
                  подписывать
                  никаких актов сверок, в том числе выписывать чеки и т. п.</p>
                <p>ІІІ. Дополнительные условия</p>
                <p>3.1. Договор вступает в силу с момента достижения Сторонами всех существенных условий Договора и
                  действует до полного исполнения Сторонами обязательств, предусмотренных Договором и
                  дополнительными приложениями к нему.</p>
                <p>3.2. Стороны достигли согласия и подтверждают, что этот Договор может подписываться путем
                  воспроизведения подписи с помощью средств механического или иного копирования,
                  электронно-цифровой
                  подписи либо иного aнaлoга собственноручной подписи (в частности, путем нанесения подписей на
                  электронных средствах собственноручной подписи (в том числе, планшете).</p>
                <p>3.3. Кроме этого, Стороны согласились, что обмен документами и информацией, в частности, посредством
                  электронной почты (реквизиты которой указаны Принципалом и Агентом в Приложении
                  № 1
                  к
                  настоящему Договору), а также путем телефонных переговоров, по факсу или любыми другими действиями (в
                  том числе, совершение Принципалом действий на веб-сайте Агента) является
                  дополнительным
                  подтверждением существования правоотношений, возникших по этому Договору.</p>
                <p>3.4. Условия настоящего Договора принимаются Принципалом без каких-либо возражений и соответствуют
                  его действительной воле как Принципала. Принципал уяснил значение используемых в
                  договоре
                  терминов, слов и выражений согласно их нормативно-правовому определению и (или) толкованию в
                  соответствии с законодательством Российской Федерации.</p>
                <p>3.5. Стороны договорились, что Агент не несёт ответственности перед Принципалом за утрату или
                  повреждение Товара. Агент не несёт ответственность за сохранность Товара.</p>
                <p>3.6. Существующие приложения к этому Договору, а также те приложения, которые могут быть заключены в
                  будущем, являются неотъемлемой частью настоящего Договора.</p>
                <p>Принципал: <strong>{{ order.client_name || (order.client && order.client.name) }}</strong></p>
                <div class="sign_editor">
                  <Editor v-if="maxWidth" :canvasWidth="maxWidth" :canvasHeight="300" ref="editor1"
                          editorId="canvasId1"/>
                </div>
                <p>Агент:</p>
                <p><strong>Компания “Rancor Distribution S.A.”</strong></p>
                <p>Republic of Panama, registration number 155591940; юридическое лицо, которое создано в Республике
                  Панама; регистрационный номер 155591940</p>
                <div class="flex justify-content-between">
                  <p>Вильчинский Виктор</p>
                  <div>
                    <img src="/assets/img/signs/vilch.png" alt="Avatar"/>
                  </div>
                </div>
              </tab>
              <tab name="Приложение">
                <p>ПРИЛОЖЕНИЕ № 1 к агентскому договору от 17.12.2021</p>
                <p>ПРИНЦИПАЛ: {{ order.client_name || (order.client && order.client.name) }} с одной стороны, и АГЕНТ:
                  Компания “Rancor Distribution S.A.”
                  (Republic of Panama, registration number 155591940; юридическое лицо, которое
                  создано в Республике Панама; регистрационный номер 155591940) от имени которой действуют: Вильчинский
                  Виктор на основании учредительных документов и Воронин Павел Евгеньевич на
                  основании доверености от от 01 февраля 2016 года , с другой стороны, вместе именуемые «Стороны», а
                  индивидуально – «Сторона», заключили это Приложение о следующем:</p>
                <p>1. Стороны согласились, что в понимании указанного выше агентского договора, который заключен между
                  ними:</p>
                <p>Принципал (ФИО) {{ order.client_name || (order.client && order.client.name) }}</p>
                <p>Телефон/факс Принципала {{
                    mixinPrintPhone(order.order_phones && order.order_phones[0] && order.order_phones[0].phone && '00' + order.order_phones[0].phone.phone)
                  }}</p>
                <p v-if="order.email">Эл. почта Принципала {{ order.email }}</p>
                <p>Товар</p>
                <table class="table table-sm">
                  <thead>
                  <tr>
                    <th>Препарат</th>
                    <th>Количество</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="detail in order.details">
                    <td>{{ detail.new_drug.title }}</td>
                    <td>{{ detail.qty }}</td>
                  </tr>
                  </tbody>
                </table>
                <p>Место доставки товара {{ order.address }}</p>
                <p>Дата доставки товара {{ moment() }}</p>
                <p>Стоимость услуг Агента по доставке товара Принципалу {{ order.price }}</p>
                <p>2. Стороны своими подписями подтверждают, что по указанному выше агентскому договору, Агент (или его
                  доверенное лицо) доставил Товар в условленное место и дату в соответствии с
                  условиями Агентского договора и настоящего Приложения, а также то, что Принципал обязан оплатить
                  услуги Агента по доставке Товара в момент непосредственной передачи Товара
                  Принципалу.</p>
                <p>3. Стороны также достигли согласия и подтверждают, что електронные письма Принципала (с указанной в
                  этом Приложении электронной почты), которые поступают на электронную почту
                  Агента,
                  являются дополнительным подтверждением письменной формы этого договора. Кроме этого, стороны
                  согласились, что обмен документами и информацией, в частности, путем телефонных
                  переговоров, по факсу или любыми другими действиями (в том числе, совершение Принципалом действий на
                  веб-сайте Агента) является дополнительным подтверждением существования
                  правоотношений, возникших по указанному выше агентскому договору.</p>
                <p>4. Принципал подтверждает свое согласие на то, что его электронная почта и телефонний номер, которые
                  указаны в этом Приложении, посредством использования кодов, паролей и другой
                  информации подтверждают факт формирования электронной подписи Принципалом.</p>
                <p>5. Принципал, заключая это приложение к указанному выше агенсткому договору, также подтверждает свою
                  личность, полную дееспособность, а также свободное волеизъявление на заключение
                  этой сделки.</p>
                <p>6. Все остальные условия вышеуказанного агентского договора действуют для Сторон в полном объеме.</p>
                <p>Принципал: <strong>{{ order.client_name || (order.client && order.client.name) }}</strong></p>
                <div class="sign_editor">
                  <Editor v-if="maxWidth" @touch="updateImage" :canvasWidth="maxWidth" :canvasHeight="300" ref="editor2"
                          editorId="canvasId2"/>
                </div>
                <p>Агент:</p>
                <p><strong>Компания “Rancor Distribution S.A.”</strong></p>
                <p>Republic of Panama, registration number 155591940; юридическое лицо, которое создано в Республике
                  Панама; регистрационный номер 155591940</p>
                <div class="flex justify-content-between">
                  <p>Вильчинский Виктор</p>
                  <div>
                    <img src="/assets/img/signs/vilch.png" alt="Avatar"/>
                  </div>
                </div>

              </tab>
            </tabs>
          </div>
        </div>

      </div>
      <div class="card-footer">
        <template v-if="!readyToSign">
          <LoadingButton
            title="Доставить"
            :loading="btnLoading"
            :onClick="() => closeOrder()"
            className="btn btn-success"
          />
          <button v-if="false" @click="readyToSign = true" class="btn btn-success">{{
              +order.pay_method !== 3 && order.credit_card_id ? 'Взять наличные и отменить предоплату' : 'Продукт доставлен и заказчик готов расписаться в получении'
            }}
          </button>
        </template>
        <template v-else>

          <div class="mb-4">
            <div
              class="btn-group btn-group-toggle divisions_select"
              v-bind:class="[{ disabled: btnLoading }]"
            >
              <label
                v-bind:class="[
              { active: salaryRate == 0 },
              'btn btn-outline-primary'
            ]"
              >
                <input
                  :disabled="btnLoading"
                  v-model="salaryRate"
                  type="radio"
                  :value="0"
                  autocomplete="off"
                />
                <div>
                  <p class="division_runner">Стандарт</p>
                </div>
              </label>
            </div>
            <div
              class="btn-group btn-group-toggle divisions_select"
              v-bind:class="[{ disabled: btnLoading }]"
            >
              <label
                v-bind:class="[
              { active: salaryRate == 1 },
              'btn btn-outline-primary'
            ]"
              >
                <input
                  :disabled="btnLoading"
                  v-model="salaryRate"
                  type="radio"
                  :value="1"
                  autocomplete="off"
                />
                <div>
                  <p class="division_runner">Область</p>
                </div>
              </label>
            </div>
            <div
              class="btn-group btn-group-toggle divisions_select"
              v-bind:class="[{ disabled: btnLoading }]"
            >
              <label
                v-bind:class="[
              { active: salaryRate == 2 },
              'btn btn-outline-primary'
            ]"
              >
                <input
                  :disabled="btnLoading"
                  v-model="salaryRate"
                  type="radio"
                  :value="2"
                  autocomplete="off"
                />
                <div>
                  <p class="division_runner">Дальняя ставка</p>
                </div>
              </label>
            </div>
          </div>

          <LoadingButton
            title="Доставить"
            :loading="btnLoading"
            :onClick="() => closeOrder()"
            className="btn btn-success"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import LoadingButton from '@/components/buttons/LoadingButton'
import Editor from 'vue-image-markup'
import {Tabs, Tab} from 'vue-tabs-component'
import moment from 'moment'
import EmptyModal from "@/components/modals/EmptyModal";

export default {
  components: {
    EmptyModal,
    Editor,
    LoadingButton,
    Tabs,
    Tab,
  },
  data() {
    return {
      loadingRequestBtn: {},
      loading: false,
      btnLoading: false,
      modalData: null,
      maxWidth: 0,
      loadingColor: this.$constants.LOADING_COLOR,
      order: null,
      readyToSign: false,
      salaryRate: 0,
      signed: {1: false, 2: false},
      attemptsWOSignature: 0,
    }
  },
  mounted() {
    this.maxWidth = this.$refs.mainContent.clientWidth - 35
    this.getOrder()
  },
  watch: {
    'readyToSign': {
      handler: function (val, oldVal) {
        if (this.readyToSign) {
          setTimeout(() => {
            this.$refs.editor1.set('freeDrawing', {
              strokeWidth: '5',
            })
            this.$refs.editor2.set('freeDrawing', {
              strokeWidth: '5',
            })

            const elements = document.querySelectorAll('.canvas-container canvas')
            elements[1].addEventListener('touchstart', (event) => {
              this.updateImage(1)
            }, false)
            elements[3].addEventListener('touchstart', (event) => {
              this.updateImage(2)
            }, false)
          }, 500)
        }
      },
      deep: true
    },
  },
  methods: {
    async requestNoCashPayment(order) {
      this.loadingRequestBtn[order.id] = true;
      this.loadingRequestBtn = {...this.loadingRequestBtn}
      const {data} = await api.post('/new/orders/updateByAction', {
        order_id: this.order.id,
        action: 'setPrePaidData',
      });
      if (data.success) {
        toastr['success']('Реквизиты выданы, обновляйте периодически статус заявки для поиска оплаты');
        await this.getOrder();
      } else {
        toastr['warning'](data.message || 'сервер не ответил', 'Ошибка')
      }
      this.loadingRequestBtn[order.id] = false;
    },
    onModalClose() {
      this.modalData = null;
    },
    async sendUpdateStatusRequest(send = false) {
      if (!send) {
        this.modalData = {
          header: 'Запрос менеджеру на обновление статуса предоплаты',
          message: 'Пожалуйста подтвердите поступление средств за оплату заявки.'
        };
      } else {
        if (!this.modalData.message) {
          toastr['warning']('Сообщение не может быть пустым', 'Ошибка')
          return;
        }
        this.$refs.emptyModal.acceptBtnLoading = true;
        const {data} = await api.post('/new/chat/dialog', {
          type: 1,
          order_id: this.order.id,
          message: this.modalData.message
        })
        if (data.success) {
          toastr['success']('Обновите статус заявки через 2 минуты', 'Отправлено');
          this.onModalClose();
        } else {
          toastr['warning'](data.message || 'сервер не ответил', 'Ошибка')
        }
      }
    },
    async closeOrder() {
      if (this.btnLoading) return
      this.btnLoading = true
      // const emptyImage = 'data:image/png;base64,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';
      if (false && this.attemptsWOSignature < 3 && Object.values(this.signed).find((s) => !s) !== undefined) {
        ++this.attemptsWOSignature
        toastr['warning']('Договор и приложение должны быть подписаны', 'Ошибка')
        this.btnLoading = false
        return
      }
      // const sign_1 = this.$refs.editor1.saveImage()
      // const sign_2 = this.$refs.editor2.saveImage()
      const {data} = await api.post('orders/runnerCloseOrder', {
        order_id: this.order.id,
        // sign_1: sign_1,
        // sign_2: sign_2,
        updateSalaryRate: this.salaryRate
      })
      if (data.success) {
        toastr['success'](data.message || 'Заявка доставлена', 'Успешно')
        this.mixinGoToRouter('TabletMyOrders')
      } else {
        toastr['warning'](data.message || 'нет ответа сервера', 'Ошибка')
      }
      this.btnLoading = false
    },
    updateImage(image) {
      this.signed[image] = true
    },
    async getOrder() {
      // if (!this.$route.params.orderId) {
      //   this.$route.params.orderId = 864371;
      //   // return;
      // }
      this.loading = true
      const {data} = await api.index('orders/gerRunnerOrder/' + this.$route.params.orderId)
      if (data.success) {
        this.order = data.order
        this.salaryRate = data.order.extra_options.salary_rate || 0
      } else {
        toastr['warning'](data.message || 'нет ответа сервера', 'Ошибка')
      }
      this.loading = false
    },
    clear() {
      this.$refs.editor.clear()
    },
    moment: function (date = null, format = 'DD.MM.YYYY', object = false) {
      if (!date) {
        date = moment().format()
      }
      const objectDate = moment(date)
      if (object) return objectDate
      return objectDate.format(format)
    },
  }
}

</script>

<style scoped>
.fs-18 {
  font-size: 18px;
}

.card-footer .btn {
  width: 100%;
  margin-bottom: 3px;
}

.card-header .btn {
  position: absolute;
  right: 5px;
  top: 5px;
}

p {
  margin-bottom: 2px;
}

.sign_editor {
  overflow: hidden;
  border: 1px solid lightgray;
}

.text_block p {
  margin-bottom: 10px;
}
</style>
